import { SiteActivite } from './site-activite.model';
import { DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Site {
    static jsonMap = {
        id: { key: 'id', optional: true },
        adresse: { key: 'adresse', optional: true, default: '' },
        responsable: { key: 'responsable', optional: true, default: '' },
        siteActivites: { key: 'refSiteActiviteIds', converter: new (DataIdArrayConverterFactory.build(SiteActivite, 'sitesActivites'))(), default: () => [] }
    };

    id: number;
    adresse: string;
    responsable: string;
    siteActivites: SiteActivite[];
}
